import { Popper as MuiPopper, PopperProps } from '@mui/material'

import { styled } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

export const Popper: MsdkStyledComponent<PopperProps> = styled(MuiPopper)``
